import { HasId } from '../../../../shared/basic-data-management/has-id.interface';
import { ParcBase } from './parc-base.entity';

export class ParcTLR extends ParcBase implements HasId {
	id!: number;

	constructor() {
		super();
	}
}